/* eslint-disable */
import { useDispatch } from "react-redux";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { setStepDetails } from "src/redux/Actions/common";
import ReviewHeading from "../../../../shared/ReviewHeading";
import MedicalAndLifestyle from "../../../../shared/MedicalLifeStyle";
// import { Dispatch, SetStateAction } from "react";
import CustomButton from "src/shared/CustomButton";
import { useFormik } from "formik";
import { ProperdetailMedicalSchema } from "src/helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle";
import { useEffect } from "react";
import {
  displayAdditionalQue,
  getQuestionnaireMapper
} from "src/helpers/FormDetails/ProposalDetails/MedicalAndLifeStyle/mapper";
import { calcAgeFromToday } from "src/helpers/FormDetails/ProposalDetails/resources";

function MedicalAndLifeStyle() {
  const dispatch = useDispatch();
  const gender = useAppSelector((state) => state.proposerDetails.general?.gender);
  const reviewStepNumber = useAppSelector((state): any => state.stepDetails.reviewStepNo);
  const MedicalAndLifeStyleData = useAppSelector((state: any) => state.medicalAndLifeStyle);
  const productId = useAppSelector((state) => state.common?.productId)!;
  const partnerId = useAppSelector((state) => state.common?.leadDetails?.partnerId)!;

  const medicalQuestions = getQuestionnaireMapper(productId, partnerId);

  const sumAssured = useAppSelector((state) => state?.common?.leadDetails?.sumAssured);
  const primaryLifeDob = useAppSelector((state) => state?.proposerDetails?.general?.dob) || "";
  const toDisplayAdditionalQue = displayAdditionalQue(sumAssured, primaryLifeDob);

  const age = calcAgeFromToday(primaryLifeDob);

  const values = useFormik({
    enableReinitialize: true,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    initialValues: MedicalAndLifeStyleData,
    validationSchema: ProperdetailMedicalSchema(productId, age, partnerId),

    onSubmit: (fieldValues) => {
      //  console.log("fieldValues", values);
    }
  });

  useEffect(() => {
    if (gender === "Male") {
      values.setFieldValue("medicalDetails.gyneComplications", false);
      values.setFieldValue("medicalDetails.pregnant", false);
      values.setFieldValue("medicalDetails.pregnancyDuration", "");
    }
  }, []);

  function onBack() {
    // setStepNo(stepNo - 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber - 1 }));
    window.scrollTo(0, 0);
  }
  function onNext() {
    // setStepNo(stepNo + 1);
    dispatch(setStepDetails({ reviewStepNo: reviewStepNumber + 1 }));
    window.scrollTo(0, 0);
  }
  return (
    <div className="  font-montserrat">
      <div className="xl:ml-10 xl:mr-10 lg:ml-10 lg:mr-10 md:ml-10 md:mr-10 ml-4 mr-4">
        <ReviewHeading label="Medical & LifeStyle" />
      </div>
      <MedicalAndLifestyle
        questions={medicalQuestions}
        displayAdditionalQue={toDisplayAdditionalQue}
        isReview
        label="Self"
        formValues={MedicalAndLifeStyleData}
        setFieldTouch={values.setFieldTouched}
        setFieldValue={values.setFieldValue}
        gender={gender}
      />
      <div className="pb-10">
        <CustomButton onBack={onBack} onNext={onNext} />
      </div>
    </div>
  );
}

export default MedicalAndLifeStyle;
